// todoの一覧
import {db} from '../../main'
import store from '../../store'
import todoManager from '@/assets/js/todoManager.js'

const nmax = 5
export const todos = {
  namespaced: true,
  state: {
    list: [],
    query: {
      isDone: false
    },
    hasMore: false
  },
  mutations: {
    init (state) {
      state.list = []
      state.query = {
        isDone: false
      }
    },
    addList (state, list) {
      for (let i = 0; i < list.length; i++) {
        state.list.push(list[i])
      }
    },
    queryDone (state) {
      state.query.isDone = true
    },
    setQuery (state) {
      state.query.isDone = false
    },
    setHasMore (state, flag) {
      state.hasMore = flag
    }
  },
  getters: {
  },
  actions: {
    async getList ({state, commit}) {
      let uid = store.state.user.uid
      let dbRef = db.collection('todos').where('members', "array-contains", uid).orderBy('metas.createdAt', 'desc')

      if (state.list.length > 0) {
        // more
        let date_startAt = state.list[state.list.length - 1].metas.createdAt
        dbRef = dbRef.startAfter(date_startAt)
      }

      let response = await dbRef.limit(nmax).get()
      let list = []
      let counter = 0
      response.forEach((doc) => {
        let todo = doc.data()
        todo.id = doc.id
        todo.list = todoManager.obj2list(todo.todos)
        todo.count = todoManager.count(todo.list)
        list.push(todo)
        counter++
      })
      if (counter === nmax) {
        commit('setHasMore', true)
      } else {
        commit('setHasMore', false)
      }
      commit('addList', list)
      commit('queryDone')
    }
  }
}
